import { useEffect, useState } from 'react'
import Navbar from '../../../../components/navbar/Navbar'
import styled from './GoogleDriveBooks.module.css'
import GoBackButton from '../../../../components/buttons/GoBackButton'

const GoogleDriveBooks = () => {
  const [books, setBooks] = useState([])
  useEffect(() => {
    fetch('/bookLinks.json')
      .then((res) => res.json())
      .then((data) => setBooks(data))
      .catch((err) => console.error('Failed to load books', err))
  }, [])

  return (
    <>
    <Navbar />
    <div className={styled.container}>
      <h4>Study books: {books.length}</h4>
      <div className={styled.lesson}>
        {books.map((book, idx) => (
          <div className={styled.event} key={`${book.title}-${idx}`}>
            <p>{book.title}</p>
            <p>
              <a href={book.url} target="_blank" rel="noopener noreferrer">
                See the books <span className={styled.arrow}>→</span>
              </a>
            </p>
          </div>
        ))}
      </div>
      <GoBackButton />
    </div>
    </>
  )
}

export default GoogleDriveBooks
